import { useFragment } from "react-relay";

import { useFacilityAllowsRefunds_facility$key } from "./__generated__/useFacilityAllowsRefunds_facility.graphql";

const graphql = require("babel-plugin-relay/macro");

export const useFacilityAllowsRefunds = (
  facilityRef: useFacilityAllowsRefunds_facility$key | null | undefined
) => {
  const facility = useFragment(
    useFacilityAllowsRefundsFragmentString,
    facilityRef
  );

  // Default to allow refunds by default
  return facility?.squarePosConfiguration?.allowWhooshRefunds ?? true;
};

const useFacilityAllowsRefundsFragmentString = graphql`
  fragment useFacilityAllowsRefunds_facility on Facility {
    squarePosConfiguration {
      allowWhooshRefunds
    }
  }
`;
